module.exports = __webpack_public_path__ + "static/media/carIcon.5fe17f48.svg";